import { Button, Flex, Text, Textarea } from "@chakra-ui/react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useGenerateRecipeFromText } from "../../../hooks";

type FormInputs = {
  extractedText: string;
};

type Props = {
  onBack?: () => void;
  onSave?: () => void;
};

const GenerateRecipeFromTextForm = ({ onSave }: Props) => {
  const methods = useForm<FormInputs>();
  const { generateRecipeFromText, isLoading } = useGenerateRecipeFromText({});

  const {
    register,
    setValue,
    handleSubmit,
    watch,
    formState: { errors },
  } = methods;

  const recipeText = watch("extractedText");

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    // importFromInstagramMutate(data.url);
    generateRecipeFromText(data.extractedText);
    toast.loading(
      "We're currently processing this recipe. it can take between 30-60 seconds to generate it. Keep this page open and we'll let you know when it's ready!",
      { duration: 15000 }
    );
    onSave && onSave();
    console.log(data);
  };

  const wordCount = recipeText?.split(/\s+/)?.length;

  return (
    <FormProvider {...methods}>
      <form
        onKeyPress={(e) => {
          if (e.key === "enter") {
            e.preventDefault();
          }
        }}
        // style={{ height: "100%" }}
        id="ExtractRecipeFromImage"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Flex direction={"column"} paddingLeft={5}>
          <Text>
            If you have text from a recipe, you can paste it here to generate a
            recipe. This could be text copied from an image (available in the
            latest iOS and android versions) Or copied from a website.
          </Text>
        </Flex>
        <Flex p="25px" direction="column" gap="10px" height="100%">
          <Textarea
            {...register("extractedText")}
            placeholder="Extracted text will appear here"
          />
          {wordCount > 1000 && (
            <Text color="red.500">
              There is a maximum of 1000 words. Please remove any unnecessary
              words.
            </Text>
          )}
          <Button
            mt={4}
            colorScheme="brand"
            isLoading={isLoading}
            type="submit"
            form="ExtractRecipeFromImage"
          >
            Save
          </Button>
        </Flex>
      </form>
    </FormProvider>
  );
};

export default GenerateRecipeFromTextForm;
